export enum ModalLoginEmitEnum {
    Cloud = 'cloud',
    Hosting = 'hosting',
}
